// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"19":"e16b6d61","23":"811ba6df","91":"a3b8a73c","229":"d43f4d9e","371":"1316e8f4","453":"0dafe30d","613":"cbf2054e","706":"9326d168","839":"50b6b6df","964":"f445ae05"}[chunkId] + ".chunk.js";
};